import React, { useEffect, useRef } from "react";
import { RouterProvider } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserLocationFetcher  , AuthenticateUser} from "./Redux/Slices/User_Slices/User-SLICE";
import useOffline from "./Hooks/useOffline";

import router from "./Routes/Route";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Configs/AxiosConfig";
import RateLimitOverlay from "./Components/RateLimitOverlay/RateLimitOverlay";
import ResExpiredOverlay from "./Components/ResExpiredOverlay/ResExpiredOverlay";

function App() {

  const dispatch = useDispatch();

  const isOffline = useOffline();

  console.log(" offline : ", isOffline);

  // Guards against React 18 StrictMode's dev-only double-invocation of effects (and against
  // useMemo, which was used here before — the wrong tool for side effects: React may call a
  // useMemo factory more than once during render, or discard/recompute it, even outside
  // StrictMode). AuthenticateUser() consumes a ONE-TIME SSO ticket (?tk=... on the URL) when
  // arriving from the admin panel's "Visit Portal" — firing it twice burns the ticket on the
  // first call and makes the second one legitimately fail with "Authentication failed /
  // expired", even though the login actually succeeded.
  const hasAuthenticated = useRef(false);

  useEffect(() => {
    if (hasAuthenticated.current) {
      return;
    }
    hasAuthenticated.current = true;

    // These are the functions which will be loaded when user visits/revisits the site
    dispatch(UserLocationFetcher());
    dispatch(AuthenticateUser());
  }, [dispatch]);

  return (
    <>
      <ToastContainer />
      <RateLimitOverlay />
      <ResExpiredOverlay />
      {/* {isOffline ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
            backgroundColor: "#f0f0f0",
            color: "#333",
            margin: 0,
            padding: 0,
          }}
        >
          {" "}
          <h1 style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>
            YOU ARE OFFLINE
          </h1>
          <p style={{ fontSize: "1.25rem" }}>Please check your connection  .... Refresh The Page After Connecting</p>
        </div>
      ) : ( */}
        <RouterProvider router={router} />
      {/* )} */}
    </>
  );
}

export default App;
